import React from 'react'

import * as imageLabelStyles from './image-label.module.scss'

interface ImageLabelProps {
  text: string
  className?: string
}

const ImageLabel: React.FC<ImageLabelProps> = ({ text, className }) => {
  return (
    <div className={`${imageLabelStyles.imageLabel} ${className || ''}`}>
      {text}
    </div>
  )
}

export default ImageLabel
